import { render, staticRenderFns } from "./EditDrug.vue?vue&type=template&id=38fa4892&scoped=true"
import script from "./EditDrug.vue?vue&type=script&lang=js"
export * from "./EditDrug.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38fa4892",
  null
  
)

export default component.exports